import { render, staticRenderFns } from "./EditBatchOrder.vue?vue&type=template&id=728d53f4&lang=pug&"
import script from "./EditBatchOrder.vue?vue&type=script&lang=js&"
export * from "./EditBatchOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports